export default __webpack_public_path__ + "static/media/helpCenter.6c85990d.svg";